import _get from "lodash/get";
import "core-js/modules/es6.string.starts-with.js";
import isMobileJs from 'ismobilejs';
var isMobile = typeof window !== 'undefined' ? isMobileJs(window.navigator) : null;
export var isNonAppleMobileDevice = _get(isMobile, 'any') && _get(isMobile, 'apple.device') === false;
export var isAndroidMobileDevice = _get(isMobile, 'android.device');
export var isAnyMobileDevice = _get(isMobile, 'any'); // copied from my-nerdwallet
// https://github.com/NerdWallet/my-nerdwallet/blob/1af78053b0035357da2cced44acca1183a74465c/client/lib/utils.js#L21
// Determine if the current page is being rendered in a webview for custom
// mobile logic. Use the user agent which is set by mobile-only
// to start with NerdWallet in order to be sure that it is a webview.

export var isInWebView = function isInWebView() {
  if (typeof window !== 'undefined') {
    // lint preference set browser as false
    var currentUserAgent = window.navigator.userAgent;
    return currentUserAgent.startsWith('NerdWallet/');
  }

  return false;
};